import {fetchBackend, getGETUrl} from "../utils/helperFunctions";
import {NetECG, netECGSchema} from "sharedlibs";
import {z} from "zod";

export async function getAllNetECGs(query?: any): Promise<NetECG[]> {
    const netECGResponse = await fetchBackend(getGETUrl("netecg/", query))
    if (Array.isArray(netECGResponse)) {
        return netECGResponse.map((elem) => {
            return netECGSchema.parse(elem)
        })
    } else {
        throw new Error('Response is not of type JSON')
    }
}

export async function getNetECGByID(id: string): Promise<NetECG | undefined> {
    const netECGResponse = await fetchBackend(getGETUrl(`netecg/by-id/${id}`, {}))
    return netECGSchema.parse(netECGResponse[0])
}


export async function getCustomersNetECGs(customerId: string): Promise<NetECG[] | undefined> {
    const netECGResponse = await fetchBackend(getGETUrl(`netecg/by-customer/${customerId}`, {}))
    return z.array(netECGSchema).parse(netECGResponse[0])
}

export async function editNetECG(netECG: NetECG) {
    await fetchBackend(getGETUrl("netecg/", {}), 'PUT', netECG)
}

export async function addNetECG(netECG: NetECG) {
    await fetchBackend(getGETUrl("netecg/", {}), 'POST', netECG)
}

export async function deleteNetECG(id: string) {
    await fetchBackend(getGETUrl(`netecg/${id}`, {}), 'DELETE')
}
